const NATIVE_BROWSER_REDIRECT_PARAM = '_nb'

const IN_APP_UA_PATTERNS: Array<{ pattern: string; app: string }> = [
  { pattern: 'linkedinapp', app: 'LinkedIn' },
  { pattern: 'fban', app: 'Facebook' },
  { pattern: 'fbav', app: 'Facebook' },
  { pattern: 'fbios', app: 'Facebook' },
  { pattern: 'fb_iab', app: 'Facebook' },
  { pattern: 'fbss', app: 'Facebook' },
  { pattern: 'instagram', app: 'Instagram' },
  { pattern: 'line', app: 'LINE' },
]

export type InAppBrowserPlatform = 'ios' | 'android'

export interface InAppBrowserInfo {
  platform: InAppBrowserPlatform
  app: string | null
}

export function detectInAppBrowser(): InAppBrowserInfo | null {
  const ua = navigator.userAgent.toLowerCase()
  const matchedEntry = IN_APP_UA_PATTERNS.find(({ pattern }) => ua.includes(pattern))
  // "; wv)" is the precise Android WebView marker
  const isAndroidWebView = /android/.test(ua) && /; wv\)/.test(ua)
  if (!matchedEntry && !isAndroidWebView) {
    return null
  }

  const isIOS = /iphone|ipad|ipod/.test(ua)
  const isAndroid = /android/.test(ua)

  return {
    platform: isIOS ? 'ios' : isAndroid ? 'android' : 'android',
    app: matchedEntry?.app ?? null,
  }
}

/** Returns true if a redirect was already attempted (loop guard). */
export function alreadyAttemptedRedirect(): boolean {
  return new URLSearchParams(window.location.search).has(NATIVE_BROWSER_REDIRECT_PARAM)
}

/**
 * Redirects to the native browser.
 * Adds a loop-guard param to the target URL so we can detect if the redirect failed.
 */
export function redirectToNativeBrowser(platform: InAppBrowserPlatform): void {
  const params = new URLSearchParams(window.location.search)
  params.set(NATIVE_BROWSER_REDIRECT_PARAM, '1')
  const targetUrl = window.location.origin + window.location.pathname + '?' + params.toString() + window.location.hash

  if (platform === 'ios') {
    // x-safari-https:// opens Safari directly — confirmed working on latest iOS
    window.location.href = targetUrl.replace(/^https/, 'x-safari-https')
  } else {
    // intent:// opens Chrome on Android; falls back to default browser if Chrome not installed
    const withoutProtocol = targetUrl.replace(/^https?:\/\//, '')
    window.location.href = `intent://${withoutProtocol}#Intent;scheme=https;package=com.android.chrome;end`
  }
}

export async function copyCurrentUrl(): Promise<void> {
  await navigator.clipboard.writeText(window.location.href)
}
